import {
  EthnicityIcon,
  AgeIcon,
  GenderIcon,
  EarlyVoteIcon,
  PartisanshipIcon,
  UrbanicityIcon,
  MaritalStatusIcon,
  IncomeIcon,
  PresenceOfChildrenIcon,
  EducationIcon,
  VoteHistoryIcon,
  TurnoutScoresIcon,
  ScoresIcon,
  TrueViewsIcon,
} from "@murm/ant";

export const searchSuggestions = [
  "partisanship in North Carolina by county",
  "abortion support in FL congressional districts",
  "New York",
  "state upper houses in TX",
  "Trump support in Los Angeles County, CA",
  "turnout in WY counties",
  "Shelby County",
];

export const tabColorClasses = {
  metrics: {
    main: "style-primary",
    text: "text-style-primary",
    border: "border-style-primary",
    bg: "bg-style-primary",
    ring: "ring-style-primary",
  },
  filters: {
    main: "style-secondary",
    text: "text-style-secondary",
    border: "border-style-secondary",
    bg: "bg-style-secondary",
    ring: "ring-style-secondary",
  },
  places: {
    main: "style-green",
    text: "text-style-green",
    border: "border-style-green",
    bg: "bg-style-green",
    ring: "ring-style-green",
  },
};

export const tabNames = {
  metrics: "Metrics",
  filters: "Filters",
  places: "Places",
};

export const tabDescriptions = {
  metrics:
    "Explorer offers numerous issue scores, demographic slices, and electoral behaviors to help you better understand the voters in a given area.",
  filters:
    "You can use Explorer's data catalog to filter on variety of demographic and behavioral datapoints to dial in your research.",
  places:
    "Narrow your search to one or multiple locations in the United States and, optionally, break your results down by a geography level, like a congressional district.",
};

export const icons = {
  ethnicity: <EthnicityIcon />,
  age: <AgeIcon />,
  gender: <GenderIcon />,
  early_vote: <EarlyVoteIcon />,
  partisanship: <PartisanshipIcon />,
  urbanicity: <UrbanicityIcon />,
  marital_status: <MaritalStatusIcon />,
  income: <IncomeIcon />,
  presence_of_children: <PresenceOfChildrenIcon />,
  education: <EducationIcon />,
  vote_history: <VoteHistoryIcon />,
  turnout_scores: <TurnoutScoresIcon />,
  scores: <ScoresIcon />,
  TrueViews: <TrueViewsIcon />,
};
